<script>
    import http from "@/http";

    export default {
        data: () => ({
            open: false,
            loading: false,
            r: {
                name: "",
                email: "",
                password: "",
                cpf: "",
                companies: ""
            }
        }),

        methods: {
            requestUser() {
                this.loading = true;

                const companies = this.r.companies.split(",");
                const companiesWithoutMask = companies.map(c =>
                    c.replace(/[^\d]+/g, "")
                );

                const cpf = this.r.cpf.replace(/[^\d]+/g, "");

                http.post("/requisicoes", {
                    type: 0,
                    nome: this.r.name,
                    cnpj_cpf: cpf,
                    email: this.r.email,
                    password: this.r.password,
                    empresas: companiesWithoutMask.join(","),
                    tipo_papel: 2
                })
                    .then(r => {
                        this.r = {
                            name: "",
                            email: "",
                            password: "",
                            cpf: "",
                            companies: ""
                        };
                    })
                    .catch(e => {
                        console.log(e);
                    })
                    .finally(() => {
                        this.loading = false;
                        this.open = false;
                    });
            }
        }
    };
</script>

<template>
    <section>
        <v-dialog v-model="open" max-width="600px">
            <template v-slot:activator="{ on }">
                <v-btn dark outline color="primary" v-on="on">Solicitar acesso</v-btn>
            </template>
            <form @submit.prevent="requestUser">
                <v-card>
                    <v-card-title>
                        <span class="headline">Solicitar Acesso ao Fluid</span>
                    </v-card-title>
                    <v-card-text>
                        <section style="padding: 5px">
                            <v-text-field
                                :disabled="loading"
                                v-model="r.name"
                                label="Nome completo"
                                required
                            />
                            <v-text-field
                                :disabled="loading"
                                v-model="r.email"
                                type="email"
                                label="E-mail"
                            />
                            <v-text-field
                                :disabled="loading"
                                v-model="r.password"
                                label="Senha"
                                required
                            />
                            <v-text-field :disabled="loading" v-model="r.cpf" label="CPF" required/>
                            <v-text-field
                                :disabled="loading"
                                v-model="r.companies"
                                label="CNPJ(s) estabelecimentos(s)"
                                hint="Em caso de multiplos cnpjs, separar por virgula."
                                persistent-hint
                                required
                            />
                        </section>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat @click="open = false">Cancelar</v-btn>
                        <v-btn color="primary" :disabled="loading" type="submit">Solicitar</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-dialog>
    </section>
</template>